
































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import BaseVue from "@/core/BaseVue";
import TipoTramiteComponentProp from "@/helpers/tipoTramiteComponentProp.helper";
import { PropOptions } from "vue";
import BTableConfig from "@/core/BTableConfig/BTableConfig";
import TramiteBeneficiario from "@/models/tramite/tramiteBeneficiario.model";
import SolicitudCasoExtraordinarioModel from "@/models/tramite/solicitud-actulizacion/caso-extraordinario.model";
import PersonaDireccion from "@/models/persona/personaDireccion.model";
import Hogar from "@/models/hogar/hogar.model";
import Persona from "@/models/persona/persona.model";
import Beneficiario from "@/models/beneficiario/beneficiario.model";
import TipoTramite from "@/models/tipoTramite";
import BaseHttpClient from "@/core/HttpResources/BaseHttpClient";
@Component
export default class SolicitudCasoExtraordinarioResumen extends BaseVue {
  @Prop() readonly tipoTramite!: TipoTramite;
  @Prop() readonly solicitante!: Persona;
  @Prop() readonly beneficiario!: Beneficiario;
  @Prop() readonly content!: TramiteBeneficiario;

  model: any = null;
  direccionId = 0;
  cambioJefeId = 0;
  inclusionId = 0;
  exclusionId = 0;
  correccionId = 0;
  get tramiteBeneficiarioId() {
    if (this.content && this.content.id) return this.content.id;
    if (this.$route.params.id) return this.$route.params.id;
    return 0;
  }

  async mounted() {
    if (this.tramiteBeneficiarioId) {
      let result = (await new BaseHttpClient(
        "TramiteBeneficiarioResumen"
      ).getAsync("GetCasoExtraordinario", {
        tramiteId: this.tramiteBeneficiarioId
      })) as any;

      this.model = result.model;
      this.direccionId = result.direccionId;
      this.inclusionId = result.inclusionId;
      this.exclusionId = result.exclusionId;
      this.correccionId = result.correccionId;
      this.cambioJefeId = result.cambioJefeId;
    }
  }
  verResumenCD() {
    if (this.direccionId)
      this.$router.push(`/resumen-solicitud/${this.direccionId}`);
  }
  verResumenCCFI() {
    if (this.inclusionId)
      this.$router.push(`/resumen-solicitud/${this.inclusionId}`);
  }
  verResumenCCFE() {
    if (this.exclusionId)
      this.$router.push(`/resumen-solicitud/${this.exclusionId}`);
  }
  verResumenCCFC() {
    if (this.correccionId)
      this.$router.push(`/resumen-solicitud/${this.correccionId}`);
  }

  verResumenCJH() {
    if (this.correccionId)
      this.$router.push(`/resumen-solicitud/${this.cambioJefeId}`);
  }
}
